import { translate } from "@/i18n";
import store from "@/store";

export default {
    install(app) {
        app.config.globalProperties.$store = store;
        app.config.globalProperties.$t = (key, params) =>
            translate(key, params, store.state.locale?.locale || "zh");
    },
};
